import React from 'react'
import { useTranslation } from 'react-i18next'
import { StopSquareIcon } from 'src/editor/shared/icons/stop-square-icon'
import { ButtonSizeEnum, GhostButton } from 'src/editor/shared/ui-lib/buttons'

interface ToggleButtonProps {
  iconClassName?: string
  toggle: () => void
  active?: boolean
}

export const TogglePopupButton = ({
  toggle,
  active = false,
}: ToggleButtonProps) => {
  const { t, i18n } = useTranslation()
  const isLoading = !i18n.language

  return (
    <GhostButton
      size={ButtonSizeEnum.Medium}
      onClick={toggle}
      title={t('core.header.pop_up.title')}
      hasSkeleton={isLoading}
      active={active}
      iconBefore={<StopSquareIcon />}
    >
      {t('core.header.pop_up.label')}
    </GhostButton>
  )
}
